import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from "react-toastify";
import axios from "axios";
import Cookies from 'js-cookie';

// AsyncThunk to handle login
export const loginUser = createAsyncThunk(
    'auth/loginUser',
    async (_, { rejectWithValue }) => {
      try {
        const token = Cookies.get('authToken'); // Get the token from cookies
        if (!token) throw new Error('No token found');


        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL_USER_INFO}/public/users/user_info`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        return response.data.Response; // Extract user data correctly
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Login failed');
      }
    }
  );

// // Async thunk to handle password reset
// export const resetPassword = createAsyncThunk(
//     "auth/resetPassword", 
//     async ({ password, confirmPassword, token }, { rejectWithValue }) => {
//         try {
//             const response = await axios.post(
//                 "https://an2sldwgo0.execute-api.ap-south-1.amazonaws.com/stage1/public/user/reset-password",
//                 { password, confirmPassword, token },
//                 { headers: { "Content-Type": "application/json" } }
//             );
//             return response.data;
//         } catch (error) {
//             return rejectWithValue(error.response?.data || "Failed to reset password");
//         }
//     }
// );

// // Async Thunk code to handle forgotPassword
// export const forgotPassword = createAsyncThunk(
//     "auth/forgotPassword",
//     async (email, { rejectWithValue }) => {
//         try {
//             const response = await axios.post(
//                 'https://an2sldwgo0.execute-api.ap-south-1.amazonaws.com/stage1/public/user/forgot-password',
//                 { email },
//                 {
//                     headers: {
//                         'Content-Type': 'application/json',
//                     }
//                 }
//             );
//             return response.data; 
//         } catch (error) {
//             return rejectWithValue(error?.response?.data || 'Failed to send the request.');
//         }
//     }
// );